(() => {
  angular
    .module('app.report')
    .controller('FilterModalController', FilterModal);

  FilterModal.$inject = [
    'pid',
    'allTrackpoints',
    'includedReportItems',
    'ReportItem',
    'EventsService',
  ];

  function FilterModal(
    pid,
    allTrackpoints,
    includedReportItems,
    ReportItem,
    EventsService,
  ) {
    const vm = this;

    vm.disableBt = true;
    vm.allTrackpoints = allTrackpoints;

    activate();
    function activate() {
      angular.forEach(vm.allTrackpoints, tp => {
        angular.forEach(includedReportItems, ri => {
          if ((tp.cid === ri.cid) && (tp.tailcode == ri.tailcode)) {
            tp.active = ri.active;
            tp.affinity = ri.affinity;
          }
        });
      });
    }

    vm.getLabelName = eventType => EventsService.getLabelName(eventType);
    vm.active = () => _.filter(vm.allTrackpoints, tp => tp.active);
    vm.isAllChecked = () => _.every(vm.allTrackpoints, tp => tp.active);
    vm.toggleAll = () => {
      const checked = vm.isAllChecked();
      angular.forEach(vm.allTrackpoints, tp => tp.active = !checked);
    };

    vm.apply = () => {
      var data = {};
      var reportItemsToExclude = [];

      angular.forEach(vm.allTrackpoints, tp => {
        if (!tp.active) {
          angular.forEach(tp.eventTypes, (isEnabled, eventType) => {
            if (isEnabled) {
              const reportItemToExclude = {
                cid: tp.cid,
                evid: `${eventType}:${tp.cid}:${tp.tailcode}`,
                tailcode: tp.tailcode,
                eventType,
              };
              reportItemsToExclude.push(reportItemToExclude);
            }
          });
        }
      });

      data[pid] = reportItemsToExclude;

      ReportItem.exclude(data, () => location.reload());
    };
  }
})();
